export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.da8da73f.svg";